// TODO: Check if URL works with polyfills in IE11. If so, use that instead of own magic.

export function stringToQuery(string = '') {
  return string
    .replace(/^(http[^?]*)?\??([^#]*)(#.*)?/, '$2')
    .split('&')
    .filter(Boolean)
    .map(e => e.split(/=/))
    .reduce((a, e) => ({ ...a, [e[0]]: e[1] }), {})
}

export function queryToString(query = {}) {
  return Object.entries(query)
    .map(e => `${e[0]}=${e[1]}`)
    .join('&')
}

export function setQueryInUrl(url, query) {
  const [u, q = '', h = ''] = (url.match(/^([^?#]+)(\?[^#]*)?(#.*)?/) || []).slice(1)
  return `${u}?${queryToString({ ...stringToQuery(q), ...query })}${h}`
}
